import { useMemo } from "react";
import TemplateList from "template-store/components/template-list/template-list";
import Banner from "template-store/components/banner/banner";
import { withGenericConfig } from "/contexts/generic-config-context";
import {
  getBannerDescriptionKeyForCategory,
  getBannerTitleKeyForCategory
} from "template-store/services/solution-categories-service";
import MobileTemplatesNavigation from "template-store/components/mobile-navigation/mobile-navigation-component";
import { componentStyles } from "./category-page-content.scss";

const CategoryPageContent = (props) => {
  const { solutions, categoryData, translate, allCategories } = props;

  const bannerTitle = useMemo(() => {
    return translate(getBannerTitleKeyForCategory(categoryData?.value));
  }, [categoryData]);

  const bannerDescription = useMemo(() => {
    return translate(getBannerDescriptionKeyForCategory(categoryData?.value));
  }, [categoryData]);

  return (
    <div className="category-page-content-component">
      <div className="banner-wrapper">
        <Banner
          title={bannerTitle}
          description={bannerDescription}
          titleTagComponent="h1"
          descriptionTagComponent="h3"
        />
      </div>
      <div className="mobile-navigation-wrapper">
        <MobileTemplatesNavigation allCategories={allCategories} selectedCategoryId={categoryData?.value} />
      </div>
      <div className="template-list-wrapper">
        <TemplateList solutions={solutions} context={categoryData?.value} />
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(CategoryPageContent);
